import { render, staticRenderFns } from "./pageUserInfo.vue?vue&type=template&id=040e44ca&"
import script from "./pageUserInfo.vue?vue&type=script&lang=js&"
export * from "./pageUserInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports